export const navigatorConstants = [
  { url: 'timer', label: 'Timer' },
  { url: 'backstage', label: 'Backstage' },
  { url: 'timeline', label: 'Timeline' },
  { url: 'studio', label: 'Studio Clock' },
  { url: 'countdown', label: 'Countdown' },
  { url: 'info', label: 'Project Info' },
];

// default time format to use for users in 12 hour clocks
export const FORMAT_12 = 'h:mm:ss a';
// default time format to use for users in 24 hour clocks
export const FORMAT_24 = 'HH:mm:ss';
